export * as SharedFreeTrial from './FreeTrial';

// The role gates the dashboard's controls read. Exported flat, not namespaced, because
// dashboard-api reads the same names from the package root — one vocabulary on both sides.
export * from './role-capabilities';
export type { UserRole } from './types/UserRole';
export { DEFAULT_DESKTOP_USER_AGENT, DEFAULT_MOBILE_USER_AGENT } from './userAgent';
export { CF_TOKEN_PATTERN, containsCredential, redactCredentials } from './credential-pattern';
export {
  CF_BETA_FEATURE,
  CF_BETA_BLOCK_FEATURE,
  PRERENDER_EMAIL_SUFFIX,
  canEnterCfBeta,
  isPrerenderStaffEmail,
} from './cf-beta-access';
export { CF_FAILURE_REASONS, type CfFailureReason } from './cf-failure-reason';
export { AUDIT_LOG_RETENTION_MONTHS } from './audit-log-retention';

export * as AggregatedMetrics from './types/AggregatedMetrics';

import * as AbTestingUtils from './ab-testing-utils';
import * as ABTestingTypes from './types/ABTesting';

export const SharedABTesting = {
  ...AbTestingUtils,
  ...ABTestingTypes,
};
